import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '@/config/paths';
import { readValue, valueText } from './records';
import type { AnalyticsObject } from './schema';

/**
 * Opens a table row's form: the record page for tables with an ID (all fields and related
 * records), otherwise `row` is set for `RecordDrawer`, which shows every field of the row.
 */
export function useRecordOpener(object: AnalyticsObject) {
  const navigate = useNavigate();
  const [row, setRow] = useState<object | null>(null);
  const idColumn = object.entity?.idColumn;

  const open = useCallback(
    (record: object) => {
      const id = idColumn ? valueText(readValue(record, idColumn)) : '';
      if (id) void navigate(paths.analytics.record(object.key, id));
      else setRow(record);
    },
    [idColumn, navigate, object.key],
  );
  const close = useCallback(() => {
    setRow(null);
  }, []);
  return { open, row, close };
}
